/** @format */

import React from 'react';
import GridItem from '../../../../components/Grid/GridItem';
import CustomMultiSelect from '../../../../components/Form/CustomMultiSelect';
import { FractionCollectionInterface } from '../../../../interfaces/collections/FractionCollectionInterface';

interface FractionFormProps {
    fractionsList: FractionCollectionInterface | null;
    fractionId: Array<number>;
    handleChangeMultiple: (event: any) => void;
}

const FractionForm = (props: FractionFormProps): React.ReactElement => {
    return (
        <GridItem xs={4}>
            <CustomMultiSelect
                callback={props.handleChangeMultiple}
                value={props.fractionId}
                name={'fractionId'}
                isElementsFromApi={true}
                elements={props.fractionsList}
                elementItemValue={'id'}
                elementItemName={'mainname'}
                label={'specialized_report:h.fractions'}
                showSelectAllButton
            />
        </GridItem>
    );
};

export default FractionForm;
